import { render } from "./WatchAllTV.vue?vue&type=template&id=5cd63260&scoped=true"
import script from "./WatchAllTV.vue?vue&type=script&lang=js"
export * from "./WatchAllTV.vue?vue&type=script&lang=js"

import "./WatchAllTV.vue?vue&type=style&index=0&id=5cd63260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd63260"]])

export default __exports__